import { CreditAnalysis } from '../types';

export const getRatingColor = (rating: string | undefined): { bg: string; text: string } => {
    if (!rating || rating === '-') return { bg: 'bg-red-600', text: 'text-white' };
    const r = rating.toUpperCase();
    if (r === 'TBD') return { bg: 'bg-[#d9d9d9]', text: 'text-black' };
    if (r.startsWith('AA')) return { bg: 'bg-[#57bb8a]', text: 'text-white' };
    if (r.startsWith('A')) return { bg: 'bg-[#b6d7a8]', text: 'text-black' };
    if (r.startsWith('B')) return { bg: 'bg-[#fff2cc]', text: 'text-black' };
    if (r.startsWith('C')) return { bg: 'bg-[#f9cb9c]', text: 'text-black' };
    if (r.startsWith('D')) return { bg: 'bg-[#ea9999]', text: 'text-white' };
    if (r.startsWith('E')) return { bg: 'bg-[#d5a6bd]', text: 'text-black' };
    if (r.startsWith('F')) return { bg: 'bg-[#a64d79]', text: 'text-white' };
    return { bg: 'bg-red-600', text: 'text-white' };
};

export const fmtCurrency = (v: string | number) => {
    if (!v || v === '0.0' || v === '0') return '-';
    const n = typeof v === 'string' ? parseFloat(v) : v;
    if (isNaN(n)) return '-';
    return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

export const fmtPercent = (v: string) => {
    if (!v || v === '#DIV/0!' || v === '0') return '-';
    const n = parseFloat(v);
    return isNaN(n) ? v : `${(n * 100).toFixed(2)}%`;
};

export const fmtMil = (v: string | undefined) => {
    if (!v) return '-';
    const n = parseFloat(v);
    if (isNaN(n)) return '-';
    return n.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

export const fmtMilDiv = (v: string | undefined) => {
    if (!v) return '-';
    const n = parseFloat(v);
    if (isNaN(n)) return '-';
    return (n / 1000).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

export const financialBg = (_: CreditAnalysis, defaultBg: string) =>
    defaultBg.includes('gray-50') ? 'bg-blue-50/40 dark:bg-blue-900/10' :
    defaultBg.includes('white') ? 'bg-blue-50/20 dark:bg-blue-900/5' : defaultBg;
